import type { TranslationKey } from '@heidi/runtime/i18n';

import { type EditActivity, getActiveEditTaskKeys } from '@heidi/growth';

// Order matches the mock note preview reveal order. `ctaKey` is optional
// because not every task needs a "look right" reinforcement — when present,
// it renders below the hint as a forest-coloured nudge toward the preview
// panel that holds the actual interactive surface.
export const EDIT_TASKS: {
  key: keyof EditActivity;
  labelKey: TranslationKey;
  hintKey: TranslationKey;
  ctaKey?: TranslationKey;
}[] = [
  {
    key: 'updatedStyle',
    labelKey: 'signup.learnBasicsUpdateNote',
    hintKey: 'signup.learnBasicsUpdateNoteHint',
    ctaKey: 'signup.learnBasicsUpdateNoteCta',
  },
  {
    key: 'usedEvidence',
    labelKey: 'signup.learnBasicsUseEvidence',
    hintKey: 'signup.learnBasicsUseEvidenceHint',
  },
  {
    key: 'createdDocument',
    labelKey: 'signup.learnBasicsReferralLetter',
    hintKey: 'signup.learnBasicsReferralLetterHint',
  },
];

interface ActiveEditTaskOptions {
  includeDetailLevelTask?: boolean;
}

/**
 * The editing tasks shown for the active locale. The legacy flow drops the
 * English-only style + abbreviations task in non-English markets, while the
 * stepped flow keeps its language-independent detail-level replacement.
 */
export function getActiveEditTasks(
  locale?: string,
  { includeDetailLevelTask = false }: ActiveEditTaskOptions = {}
): typeof EDIT_TASKS {
  if (includeDetailLevelTask) return EDIT_TASKS;
  const activeKeys = new Set(getActiveEditTaskKeys(locale));
  return EDIT_TASKS.filter((task) => activeKeys.has(task.key));
}
